import { message } from "../../../../../Utils/config/messages";

export const DOCUMENTS_UI_STRINGS = {
  TITLE: "Documents",
  SEARCH_PLACEHOLDER: "Search all documents",
  UPLOAD_BUTTON: "Upload",
  CATEGORIES_TITLE: "CATEGORIES",
  ALL_DOCUMENTS: "All documents",
  UNCATEGORIZED: "Uncategorized",
  SALES_TRACKER: "Sales Tracker",
  NEW_CATEGORY_BUTTON: "+ New category",
  FOLDER_SEARCH_PLACEHOLDER: "Search folders...",
  NO_FOLDERS_FOUND: "No folders found.",
  DOCUMENTS_ACROSS_CATEGORIES: "documents across",
  CATEGORIES: "categories",
  DOCUMENTS_IN_CATEGORY: "documents in",
  STAT_DOCUMENTS: "Documents",
  STAT_FILE_TYPES: "File types",
  STAT_TOTAL_SIZE: "Total size",
  STAT_ADDED_TODAY: "Added today",
  FILTER_LABEL: "Filter:",
  FILTER_ALL: "All",
  SEARCH_IN_CATEGORY: "Search in category...",
  FILE_NAME: "File name",
  CATEGORY_COLUMN: "Category",
  UPLOADED_ON: "Uploaded on",
  UPLOADED_BY: "Uploaded by",
  SIZE: "Size",
  ACTIONS: "Actions",
  NO_DOCUMENTS: "No documents found.",
  NEW_CATEGORY_DIALOG_TITLE: "Create New Category",
  CATEGORY_NAME_LABEL: "Category Name *",
  CATEGORY_NAME_PLACEHOLDER: "e.g. Invoices",
  CANCEL_BUTTON: "Cancel",
  CREATE_BUTTON: "Create",
  UPLOAD_DIALOG_TITLE: "Upload Document",
  CATEGORY_SELECT_LABEL: "Category *",
  SELECT_DOCUMENT_TEXT: "Click to select a document *",
  CHANGE_FILE_TEXT: "Click to change file",
  SUPPORTS_TEXT: "Supports",
  UP_TO_TEXT: "up to",
  MB: "MB",
  UPLOAD_BUTTON_TEXT: "Upload",

  // Toast messages — values sourced from central messages.js
  CATEGORY_ADDED: message.DOC_CATEGORY_ADDED,
  CATEGORY_ADD_ERROR: message.DOC_CATEGORY_ADD_ERROR,
  DOCUMENT_UPLOADED: message.DOC_UPLOADED,
  DOCUMENT_UPLOAD_ERROR: message.DOC_UPLOAD_ERROR,
  FILE_TYPE_NOT_ALLOWED: "File type not allowed. Accepted types:",
  FILE_SIZE_EXCEEDED: "File size exceeds the maximum limit of",
  CATEGORY_REQUIRED: message.DOC_CATEGORY_REQUIRED,
  FILE_REQUIRED: message.DOC_FILE_REQUIRED,
  FILES_SELECTED: "files selected",
  UPLOAD_PARTIAL_ERROR: "file(s) could not be uploaded.",
  UPLOAD_PARTIAL_SUCCESS: "file(s) uploaded successfully.",
  MIGRATION_COMPLETED: "file(s) imported successfully.",
  MIGRATION_PARTIAL_ERROR: "file(s) could not be imported.",
  MIGRATION_FAILED: "Import failed. No files were added.",

  // Category name validation
  CATEGORY_NAME_HINT: "Letters, numbers, spaces, hyphens and underscores only · max 63 chars",
  CATEGORY_SLASH_ERROR: "Slashes (/ or \\) are not allowed in category names.",
  CATEGORY_SPECIAL_CHARS_ERROR: 'The characters # ? % * : | " < > & + are not permitted.',
  CATEGORY_DOT_START_ERROR: "The name cannot start with a dot (.).",
  CATEGORY_LEADING_TRAILING_SPACE_ERROR: "The name cannot start or end with a space.",
  CATEGORY_CONSECUTIVE_SPACES_ERROR: "The name cannot contain consecutive spaces.",
  CATEGORY_MAX_LENGTH_ERROR: "The name cannot exceed 63 characters.",

  SORT_NAME: "Name",
  SORT_DATE: "Date",
  SORT_SIZE: "Size",

  DELETE_ACTION: "Delete",
  TRASH_CATEGORY: "Bin",
  DOCUMENT_DELETED: message.DOC_DELETED,
  DOCUMENT_DELETE_ERROR: message.DOC_DELETE_ERROR,
  DELETE_CONFIRM_TITLE: "Move to Bin?",
  DELETE_CONFIRM_MESSAGE:
    "This document will be moved to Bin. You can recover it at any time by moving it back to a category.",
  DELETE_CONFIRM_BUTTON: "Move to Bin",
  SYSTEM_CATEGORY_ACTION_DISABLED: "This action isn't allowed because the document belongs to a system generated category.",
  SYSTEM_CATEGORY_BADGE_TOOLTIP: "System generated category — documents here can't be moved or deleted.",

  // Folder column resizing
  RESIZE_SIDEBAR_LABEL: "Resize folder column",
  RESIZE_SIDEBAR_TOOLTIP: "Drag to resize \u00b7 double-click to reset",

  // Nested folders
  NEW_FOLDER_BUTTON: "+ New folder",
  NEW_SUBFOLDER_ACTION: "New sub-folder",
  RENAME_FOLDER_ACTION: "Rename",
  DELETE_FOLDER_ACTION: "Delete folder",
  NEW_FOLDER_DIALOG_TITLE: "Create New Folder",
  RENAME_FOLDER_DIALOG_TITLE: "Rename Folder",
  DELETE_FOLDER_DIALOG_TITLE: "Delete Folder?",
  PARENT_FOLDER_LABEL: "Parent folder",
  ROOT_LEVEL_OPTION: "(No parent — root level)",
  FOLDER_NAME_LABEL: "Folder Name *",
  FOLDER_NAME_PLACEHOLDER: "e.g. Signed",
  FOLDER_CREATED: message.DOC_CATEGORY_ADDED,
  FOLDER_CREATE_ERROR: message.DOC_CATEGORY_ADD_ERROR,
  FOLDER_RENAMED: "Folder renamed successfully.",
  FOLDER_RENAME_ERROR: "Failed to rename folder.",
  FOLDER_DELETED: "Folder deleted successfully.",
  FOLDER_DELETE_ERROR: "Failed to delete folder.",
  FOLDER_NOT_EMPTY_ERROR: "This folder is not empty. Remove its sub-folders and documents before deleting it.",
  FOLDER_ALREADY_EXISTS_ERROR: "A folder with this name already exists here.",
  DELETE_FOLDER_CONFIRM_MESSAGE: "This folder will be permanently deleted. This cannot be undone.",
  SYSTEM_FOLDER_ACTION_DISABLED: "System generated folders can't be renamed or deleted.",
  VIRTUAL_FOLDER_SUBFOLDER_DISABLED:
    "This folder is a document store rather than a folder, so it can't contain sub-folders. Files can still be uploaded into it.",
  MOVE_FOLDER_ACTION: "Move to…",
  MOVE_FOLDER_DIALOG_TITLE: "Move Folder",
  MOVE_FOLDER_BUTTON: "Move",
  MOVE_FOLDER_DESTINATION_LABEL: "Destination folder",
  MOVE_FOLDER_ROOT_OPTION: "(No parent — root level)",
  FOLDER_MOVED: "Folder moved successfully.",
  FOLDER_MOVE_ERROR: "Failed to move folder.",
  FOLDER_DOCS_PARTIAL_MOVE: "file(s) were left in the old folder. Refresh to see the current state.",

  // Unified Add Documents dialog (files / zip / folder, with an optional target folder)
  ADD_DOCUMENTS_BUTTON: "Add Documents",
  ADD_DOCUMENTS_DIALOG_TITLE: "Add Documents",
  ADD_MODE_FILES: "Files",
  ADD_MODE_ZIP: "Zip file",
  ADD_MODE_FOLDER: "Folder",
  TARGET_FOLDER_LABEL: "Folder (optional)",
  TARGET_FOLDER_LABEL_REQUIRED: "Folder *",
  TARGET_FOLDER_ROOT_OPTION: "(No folder — root level)",
  ADD_HINT_FILES_ROOT: "Supports most document types · up to 10MB per file · added at the top level of this loan's documents",
  ADD_HINT_FILES_TARGET: "Supports most document types · up to 10MB per file · added inside the selected folder",
  ADD_HINT_ZIP_ROOT: "The zip's folder structure will be mirrored at the top level of this loan's documents",
  ADD_HINT_ZIP_TARGET: "The zip's folder structure will be mirrored inside the selected folder",
  ADD_HINT_FOLDER_ROOT: "Every file and subfolder will be mirrored at the top level of this loan's documents",
  ADD_HINT_FOLDER_TARGET: "Every file and subfolder will be mirrored inside the selected folder",
  START_IMPORT_BUTTON: "Start Import",
};

export const SORT_OPTIONS = {
  NONE: "none",
  NAME_ASC: "name_asc",
  NAME_DESC: "name_desc",
  DATE_ASC: "date_asc",
  DATE_DESC: "date_desc",
  SIZE_ASC: "size_asc",
  SIZE_DESC: "size_desc",
};

export const PREDEFINED_COLORS = [
  "#f59e0b", // amber
  "#3b82f6", // blue
  "#84cc16", // lime
  "#ec4899", // pink
  "#8b5cf6", // violet
  "#14b8a6", // teal
  "#ea580c", // orange
  "#ef4444", // red
  "#a855f7", // purple
];

export const FILE_TYPE_BADGE_STYLES = {
  docx: "fileTypeBadge--docx",
  doc: "fileTypeBadge--docx",
  pdf: "fileTypeBadge--pdf",
  pptx: "fileTypeBadge--pptx",
  ppt: "fileTypeBadge--pptx",
  xlsx: "fileTypeBadge--xlsx",
  xls: "fileTypeBadge--xlsx",
  default: "fileTypeBadge--default",
};

// Sizing bounds for the drag-resizable folder column. MAX_VIEWPORT_RATIO is a runtime cap on
// top of MAX_WIDTH: a width saved on a wide monitor must not swallow the document table when the
// same user later opens the dashboard in a narrow window.
export const FOLDER_SIDEBAR_SIZING = {
  MIN_WIDTH: 200,
  MAX_WIDTH: 480,
  DEFAULT_WIDTH: 240,
  MAX_VIEWPORT_RATIO: 0.45,
  KEYBOARD_STEP: 16,
  STORAGE_KEY: "documentsDashboard.folderSidebarWidth",
  CSS_VARIABLE: "--folder-sidebar-width",
};
